import styles from "../Environment/Environment.module.css";

function Footer() {
  return (
    <footer>Version: {process.env.REACT_APP_VERSION}</footer>
  )
}

export default Footer;